import { render, staticRenderFns } from "./FilterDeliveryDriver.vue?vue&type=template&id=d80a28e0"
import script from "./FilterDeliveryDriver.vue?vue&type=script&lang=ts"
export * from "./FilterDeliveryDriver.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports